module.exports = __webpack_public_path__ + "static/media/icon-zalo.708d298f.png";